import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useStore from '../store/useStore';
import { translations } from '../translations';

export default function BackToDashboardButton() {
  const navigate = useNavigate();
  const { language } = useStore();
  const t = translations[language] || translations.ru;
  return (
    <Button
      variant="outlined"
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate('/dashboard')}
      sx={{ my: 2 }}
    >
      {t.goHome}
    </Button>
  );
}
